import { Route, Switch } from 'react-router-dom';

import './App.scss';
import HomePage from './pages/HomePage';
import TriviaPage from './pages/TriviaPage';
import ResultPage from './pages/ResultPage';
import Header from './components/layout/Header';
import Leaderboard from './pages/Leaderboard';
import Footer from './components/layout/Footer';

import { AdMob, BannerAdSize, BannerAdPosition, BannerAdPluginEvents } from '@capacitor-community/admob';


import { App as CapApp } from '@capacitor/app';

function backBtnListener() {
  if (window.location.pathname === "/" || window.location.pathname === "/HomePage") {
    const res = confirm('Are you sure you want to exit?');
    if (res) {
      CapApp.exitApp();
    }
  } else {
    window.history.back();
  }
}

function App() {
  CapApp.addListener('backButton', backBtnListener);

  // Initialize Ads
  AdMob.initialize({
    requestTrackingAuthorization: true,
    testingDevices: ['2077ef9a63d2b398840261c8221a0c9b'],
    initializeForTesting: false,
  });

  // Show Banner Ad
  AdMob.addListener(BannerAdPluginEvents.Loaded, () => {
    // Subscribe Banner Event Listener
  });

  AdMob.addListener(BannerAdPluginEvents.SizeChanged, (size) => {
    // Subscribe Change Banner Size
  });

  const options = {
    adId: 'ca-app-pub-4470794203154587/4328661358',
    adSize: BannerAdSize.BANNER,
    position: BannerAdPosition.BOTTOM_CENTER,
    margin: 0,
    // isTesting: true
    // npa: true
  };
  AdMob.showBanner(options);


  return (
    <div className="App">
      <Header />

      <main>
        <Switch>
          <Route path="/" exact>
            <HomePage />
          </Route>
          <Route path="/TriviaPage">
            <TriviaPage />
          </Route>
          <Route path="/ResultPage">
            <ResultPage />
          </Route>
          <Route path="/Leaderboard">
            <Leaderboard />
          </Route>
          <Route path="*">
            <HomePage />
          </Route>
        </Switch>
      </main>

      <Footer />
    </div>
  );
}

export default App;
